
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetopandharpurcrystacab() {



    const cardData =
    {
        keyword: 'Pune to Pandharpur Crysta Cabs Service',
        heading: 'Meghana Cab : Pune to Pandharpur Crysta Cabs Service',
        headingDescription: 'Meghana Cab offers Pune to Pandharpur Crysta Cabs Service, providing a comfortable, safe, and spiritually enriching travel experience to one of Maharashtra’s most revered pilgrimage destinations. Our Innova Crysta vehicles are perfect for family groups and senior citizens, offering plush seating, air conditioning, generous legroom, and spacious luggage capacity to ensure a stress-free journey.',


        top: 'Top Places to Visit in Pandharpur with Meghana Cab',

"topPlaces": [
  {
    "title": "Vitthal Rukmini Mandir",
    "description": "The Vitthal Rukmini Mandir is the heart and soul of Pandharpur, dedicated to Lord Vitthal (a form of Lord Krishna) and his consort Rukmini. It is one of the most sacred pilgrimage sites in Maharashtra and draws millions of devotees, especially during the Ashadhi Ekadashi and Kartiki Ekadashi yatras. Devotees believe that a visit to Pandharpur is equivalent to a journey to Vaikuntha (Lord Vishnu’s abode). The temple’s black stone idol of Vitthal standing on a brick is iconic, and the darshan—whether during peak yatra or daily rituals—is deeply spiritual and emotionally uplifting."
  },
  {
    "title": "Pundalik Temple",
    "description": "Located near the Chandrabhaga River, Pundalik Temple is dedicated to the legendary devotee of Lord Vitthal. According to mythology, it was Pundalik’s unwavering devotion to his parents that led Lord Vitthal to appear in Pandharpur. The temple stands at the spot where Lord Vitthal is believed to have waited on the brick. It’s a humble but historically significant shrine and is often visited before or after Vitthal Mandir."
  },
  {
    "title": "Chandrabhaga River (Bhima River Ghats)",
    "description": "The Chandrabhaga River (a meandering form of the Bhima River) is not only a lifeline to the region but holds immense religious significance. Pilgrims take a holy dip in the river before entering the Vitthal Temple, believing it purifies sins and prepares the soul for darshan. The ghats, especially the Vishnupad Ghat, are vibrant with rituals, bhajans, and spiritual chanting. During festivals, the riverbank is filled with devotees, sadhus, and processions."
  },
  {
    "title": "Vishnupad Temple & Ghat",
    "description": "Situated on the banks of the Chandrabhaga, the Vishnupad Temple is believed to be the place where Lord Vishnu left his footprints. Devotees bathe at the ghat here and perform rituals and offerings. It’s a serene space with deep spiritual vibes, ideal for quiet prayer, river meditation, or observing the rituals performed by others."
  },
  {
    "title": "Namdev Payari",
    "description": "Namdev Payari (Namdev’s Steps) is a sacred flight of steps at the Vitthal Temple. It is believed that the famous saint Namdev and other Varkari saints like Dnyaneshwar and Tukaram reached the divine state here. Devotees consider it a blessing to climb these steps and bow their heads before entering the temple. It holds a special place in the heart of every Varkari devotee and is an embodiment of saintly devotion."
  },
  {
    "title": "Kaikadi Maharaj Math",
    "description": "This unique spiritual math (monastery) is not just a place of worship but a vibrant storytelling space where scenes from Hindu mythology are displayed using life-size models and sculptures. Narratives from Ramayana, Mahabharata, and saint literature are showcased, making it especially attractive for children and pilgrims seeking cultural immersion. It also offers accommodation and satsangs for visitors."
  },
  {
    "title": "Gopalpura (Gopalpur Teerth Kshetra)",
    "description": "Located about 2 km from Pandharpur, Gopalpura is a holy site believed to be the spot where Lord Krishna used to graze his cows during his Pandharpur visits. A peaceful field area with a small temple and trees, it is ideal for spiritual walks, meditation, and bhajan groups. Many yatris make it a part of their spiritual itinerary when visiting Pandharpur."
  },
  {
    "title": "Iskcon Pandharpur",
    "description": "ISKCON’s presence in Pandharpur brings the global Hare Krishna movement to Maharashtra’s pilgrimage capital. The ISKCON temple offers daily kirtans, prasadam meals, Bhagavad Gita lectures, and a clean, serene temple atmosphere. Located slightly outside the town center, it is a preferred stop for international devotees and those seeking structured spiritual programs."
  },
  {
    "title": "Sant Tukaram and Sant Dnyaneshwar Mandirs",
    "description": "These temples are dedicated to the great Varkari saints who preached devotion to Vitthal through abhangas and kirtans. Pilgrims often offer prayers here to honor the spiritual lineage that connects them to Lord Vitthal. These small shrines are filled with devotional energy and are must-visits during Wari season or any pilgrimage tour."
  },
  {
    "title": "Ashadi and Kartiki Wari Route Landmarks",
    "description": "During the famous Wari pilgrimage, devotees (warkaris) travel from Alandi and Dehu to Pandharpur on foot, singing abhangas and carrying palkhis of Sant Dnyaneshwar and Sant Tukaram. Along this path, landmarks such as Wakhari village, Palkhi Visava spots, and rest ghats are set up for the yatris. Even outside of the main yatra months, these routes are visited by pilgrims retracing the steps of the saints."
  }
],

  "services": [
    {
      "name": "Pune to Pandharpur Innova Crysta Cab Booking",
      "description": "Book a reliable and comfortable Innova Crysta cab from Pune to Pandharpur, the revered pilgrimage destination of Lord Vitthal devotees. Our premium cab service ensures a smooth ride over the 210+ km stretch, with a professionally maintained vehicle, experienced chauffeur, and flexible pick-up options—making it ideal for spiritual tours, senior citizens, or group visits to the temple town."
    },
    {
      "name": "One Way Innova Crysta Pune Pandharpur",
      "description": "Looking for a one-way cab from Pune to Pandharpur? Our one-way Innova Crysta rental service provides a private, non-stop journey tailored to your schedule. Perfect for pilgrims or travelers who plan to stay longer or return by different transport, this option offers luxury without the cost of round-trip fares."
    },
    {
      "name": "Round Trip Innova Crysta Pune Pandharpur",
      "description": "Our round-trip Innova Crysta cab service is perfect for those planning a same-day or overnight journey from Pune to Pandharpur and back. With ample luggage space, AC, and professional drivers, it’s ideal for families, bhajan groups, or devotees traveling in comfort for darshan or temple events."
    },
    {
      "name": "AC Innova Crysta Taxi Pune Pandharpur",
      "description": "Travel in comfort no matter the weather with our fully air-conditioned Innova Crysta taxi service from Pune to Pandharpur. Our vehicles are equipped with dual-zone climate control, pushback seats, and smooth suspension—making the 5-6 hour road trip enjoyable and relaxing for every passenger."
    },
    {
      "name": "Chauffeur Driven Innova Crysta Pune Pandharpur",
      "description": "Let our trained, courteous chauffeurs drive you safely from Pune to Pandharpur. Our chauffeur-driven Innova Crysta service is built on professionalism, punctuality, and route familiarity—ensuring a stress-free experience for pilgrims, elders, and families visiting the holy town."
    },
    {
      "name": "Private Innova Crysta Taxi Pune Pandharpur",
      "description": "Avoid shared rides and travel on your own terms with our private Innova Crysta taxi service. Designed for comfort and privacy, this option is great for families, couples, or spiritual groups heading to Pandharpur for puja, darshan, or festivals."
    },
    {
      "name": "Online Booking Innova Crysta Cab Pune Pandharpur",
      "description": "Book your Innova Crysta cab to Pandharpur from Pune online in just a few steps. Our booking platform offers instant confirmation, transparent pricing, and multiple payment options—allowing you to schedule your pilgrimage or trip with complete ease and reliability."
    }
  ],
  "tableData": [
    ["Pune to Pandharpur Innova Crysta Cab Booking", "One Way Innova Crysta Pune Pandharpur"],
    ["Round Trip Innova Crysta Pune Pandharpur", "AC Innova Crysta Taxi Pune Pandharpur"],
    ["Chauffeur Driven Innova Crysta Pune Pandharpur", "Private Innova Crysta Taxi Pune Pandharpur"],
    ["Online Booking Innova Crysta Cab Pune Pandharpur", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Comfortable Innova Crysta Cabs from Pune to Pandharpur",
    "WhyChoosedescription": "Travel from Pune to the sacred town of Pandharpur in a spacious and comfortable Innova Crysta. Whether you’re visiting Shri Vitthal Rukmini Temple or going for Ashadi Ekadashi, our cab service ensures a safe, respectful, and smooth pilgrimage journey."
  },
  {
    "WhyChooseheading": "Spacious and Pilgrimage-Friendly Travel",
    "WhyChoosedescription": "With seating for 6–7 passengers and ample legroom, our Innova Crysta cabs are ideal for families, spiritual groups, and elderly passengers. Reclining seats, AC vents, and smooth suspension offer a peaceful experience across the 210+ km route."
  },
  {
    "WhyChooseheading": "Experienced and Respectful Drivers",
    "WhyChoosedescription": "Our drivers are trained, courteous, and familiar with pilgrimage routes. They ensure timely pickup and drop, safe driving through highways and rural roads, and help make your spiritual visit as smooth as possible."
  },
  {
    "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
    "WhyChoosedescription": "We prioritize hygiene and safety. Each Innova Crysta is thoroughly cleaned and sanitized before every journey. Regular vehicle maintenance guarantees reliability and comfort throughout your travel."
  },
  {
    "WhyChooseheading": "Flexible Booking: One-Way, Round Trip, or Extended Stay",
    "WhyChoosedescription": "Choose a package that suits your spiritual plan—be it a one-way drop, same-day return, or multi-day round trip. We also accommodate stops at nearby religious places like Akkalkot or Tuljapur if needed."
  },
  {
    "WhyChooseheading": "Transparent and Affordable Pilgrimage Pricing",
    "WhyChoosedescription": "Our fares include tolls, fuel, taxes, and driver charges with no hidden costs. We offer honest pricing with a premium travel experience, especially suited for pilgrimage travelers who seek clarity and comfort."
  },
  {
    "WhyChooseheading": "Ideal for Families, Elderly Devotees, and Small Groups",
    "WhyChoosedescription": "The Innova Crysta's comfort and accessibility make it perfect for all age groups, especially for elderly devotees needing a smooth and non-strenuous journey to Pandharpur."
  },
  {
    "WhyChooseheading": "24/7 Booking and Support for Devotional Trips",
    "WhyChoosedescription": "Our cab service is available around the clock, including early morning or late-night pickups for festival days or Ekadashi trips. Call or book online, and our team is ready to assist anytime."
  }
]























    }

const faqData = [
    {
        question: "How can I book a Crysta cab from Pune to Pandharpur?",
        answer: "You can book your cab by calling Meghana Cab at +91 9075462128 or visiting our website for easy and instant booking."
    },
    {
        question: "What is the distance and travel time between Pune and Pandharpur?",
        answer: "The distance is approximately 210 km and travel time is around 4.5 to 5 hours depending on road and traffic conditions."
    },
    {
        question: "Is the Innova Crysta suitable for a long-distance trip to Pandharpur?",
        answer: "Yes, the Innova Crysta is perfect for long trips, offering excellent comfort, air-conditioning, and ample space for passengers and luggage."
    },
    {
        question: "Can I book a one-way or round trip from Pune to Pandharpur?",
        answer: "Yes, both one-way and round-trip cab services are available as per your travel plan."
    },
    {
        question: "How many people can travel in the Innova Crysta?",
        answer: "The vehicle comfortably accommodates 6 to 7 passengers with luggage."
    },
    {
        question: "Are your cabs sanitized before each trip?",
        answer: "Yes, every cab is thoroughly cleaned and sanitized before every journey to ensure safety and hygiene."
    },
    {
        question: "Are your drivers experienced with the Pune to Pandharpur route?",
        answer: "Absolutely. Our drivers are well-experienced and familiar with this route for a safe and smooth journey."
    },
    {
        question: "What’s included in the cab fare for the Pandharpur trip?",
        answer: "Our fare includes fuel, tolls, and driver charges. Parking fees or extra waiting time may cost extra."
    },
    {
        question: "Can I stop at other places during the journey?",
        answer: "Yes, planned halts can be arranged. Please inform us while booking to customize your itinerary."
    },
    {
        question: "What are the available payment options?",
        answer: "We accept payments via UPI, debit/credit cards, net banking, and cash."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Vishal Bhosale',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Booked a Crysta from Pune to Pandharpur for a pilgrimage trip. Clean car, smooth journey, and a respectful driver.”',
    },
    {
        name: 'Mrs. Anjali Jadhav',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Wonderful service! The Innova Crysta was perfect for our group and the driver was courteous and knowledgeable.”',
    },
];























































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];








const puneToPandharpurInnovaSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Pandharpur Innova Crysta Cabs Service",
  "description": "Reliable chauffeur-driven Innova Crysta cab service from Pune to Pandharpur. Available for one way, round trip, AC taxi rides, private trips, and online booking.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Outstation Taxi Service",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-pandharpur-innova-crysta-cabs"
  }
};








    return (
        <div>

<Helmet>
  <title>Pune to Pandharpur Innova Crysta Cabs | Comfortable Taxi Service</title>
  <meta
    name="description"
    content="Book chauffeur-driven Innova Crysta cabs from Pune to Pandharpur for one way, round trip, AC taxi rides, and private travel with online booking."
  />
  <meta
    name="keywords"
    content="Pune to Pandharpur Innova Crysta Cab Booking, One Way Innova Crysta Pune Pandharpur, Round Trip Innova Crysta Pune Pandharpur, AC Innova Crysta Taxi Pune Pandharpur, Chauffeur Driven Innova Crysta Pune Pandharpur, Private Innova Crysta Taxi Pune Pandharpur, Online Booking Innova Crysta Cab Pune Pandharpur"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToPandharpurInnovaSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/28.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetopandharpurcrystacab;